import { z } from 'zod';
import { TextKey } from '@mews-commander/enums';
import { PaymentCardFormat as PaymentCardFormatDto } from '@mews-commander/data-access';
import { CustomErrorParams, CustomErrorType } from '@mews/framework';

export const enum TokenizeCardFormField {
    PaymentCardNumber = 'paymentCardNumber',
    PaymentCardExpiration = 'paymentCardExpiration',
    PaymentCardHolderName = 'paymentCardHolderName',
    PaymentCardFormat = 'paymentCardFormat',
}

export const createTokenizeCardSchema = (supportedPaymentCardTypes: string[]) =>
    z.object({
        [TokenizeCardFormField.PaymentCardNumber]: z
            .object({
                length: z.number(),
                type: z.string().optional(),
                valid: z.boolean(),
            })
            .refine((val) => val.valid === true, {
                params: {
                    errorType: CustomErrorType.Other,
                    textKey: TextKey.ValidatePaymentCard,
                } satisfies CustomErrorParams,
            })
            .refine(
                ({ type }) => type && supportedPaymentCardTypes.includes(type),
                ({ type }) => {
                    if (!type) {
                        return {
                            params: {
                                errorType: CustomErrorType.Other,
                                textKey: TextKey.ValidatePaymentCard,
                            } satisfies CustomErrorParams,
                        };
                    }

                    return {
                        params: {
                            errorType: CustomErrorType.Other,
                            textKey: TextKey.ValidatePaymentCardType,
                            substitutes: { type },
                        } satisfies CustomErrorParams,
                    };
                }
            ),
        [TokenizeCardFormField.PaymentCardExpiration]: z.string().regex(new RegExp('(0[1-9]|1[0-2])/[2-9][0-9]')),
        [TokenizeCardFormField.PaymentCardHolderName]: z.string().optional(),
        [TokenizeCardFormField.PaymentCardFormat]: z.nativeEnum(PaymentCardFormatDto),
    });

export type TokenizeCardFormValues = z.infer<ReturnType<typeof createTokenizeCardSchema>>;
